"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableSortType = _interopRequireDefault(require("./TableSortType"));
var _default = exports.default = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,
  /** The header label. */
  label: _propTypes.default.string.isRequired,
  /** Determines whether or not table can sort by header cell dataKey. */
  isSortable: _propTypes.default.bool,
  /** Determines whether or not this heading should render with sorting order arrow. */
  sortOrder: _propTypes.default.oneOf([_TableSortType.default.ASC, _TableSortType.default.DESC]),
  /**
   * A function to call when a sortable header is clicked.
   *
   * @param {String} dataKey - The header's dataKey.
   * @param {String} sortOrder - The sort order to use (ASC or DESC).
   */
  onSortClick: _propTypes.default.func
};